export function moveItem(array, fromIndex, toIndex) {
    const arr = [...array];
    const [item] = arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, item);
    return arr;
}
